import { z } from 'zod'

// how many already-created (promoted) dividend/coupon incomes exist on a broker account. drives the
// "also re-categorize N existing dividend incomes?" confirmation when the payout category mapping is
// changed — a genuinely retroactive edit the user opts into, so the count must be reported up front.
export const existingPromotedIncomeCountsResponseSchema = z.object({
  dividend: z.number().int().nonnegative(),
  coupon: z.number().int().nonnegative(),
})

export type ExistingPromotedIncomeCountsResponseDto = z.infer<
  typeof existingPromotedIncomeCountsResponseSchema
>
